import React from 'react'

const Principles = () => {

	const priciples = [
		'Dodržujeme lidská práva a důstojnost klientů bez ohledu na jejich národnost, věk rasu, pohlaví, politické přesvědčení a společenské postavení.',
		'Respektujeme individualitu osob, jejich soukromí a potřebu žít vlastním způsobem života.',
		'Podporujeme soběstačnost, nezávislost a svobodné rozhodování klientů.',
		'Přizpůsobujeme služby individuálním potřebám klientů, rychle reagujeme na jejich skutečné potřeby.',
		'Posilujeme sociální začleňování, samostatnost a aktivitu klientů.',
		'Služby poskytujeme odborně a kvalitně, na základě individuálního plánování péče.',
		'Každý člověk je naším rovnocenným partnerem, který spolurozhoduje a dle úrovně svých schopností se spolupodílí na poskytování pomoci.'
	]
		
  return (
	<section id='principles' className='container mx-auto px-2 py-3 mb-10'>
      <div className='my-3'>
        <h2 className='w-fit mx-auto text-4xl border-b-2 border-amber-500 mb-6 uppercase'>
          Naše zásady
        </h2>
		<div className='md:w-3/4 px-4 md:px-0 mx-auto'>
			<p className='text-lg'>Naše zásady zachycují a vyjadřují hodnoty, kterými se řídí pracovníci organizace při práci s klienty. Jsou v souladu s platnými normami.</p>
			<ul className='list-disc text-lg px-4 md:px-6 mt-2'>
				{
					priciples.map((onePriciple, index) =>
						<li key={index}>
							{onePriciple}
						</li>
					)
				}
			</ul>
		</div>
      </div>
	</section>
  )
}

export default Principles
